import Photo1 from '../assets/images/testimonials/photo-1.jpg';
import Photo2 from '../assets/images/testimonials/photo-2.jpg';
import Photo3 from '../assets/images/testimonials/photo-3.jpg';

import Avatar1 from '../assets/images/testimonials/avatars/avatar-1.jpg';
import Avatar2 from '../assets/images/testimonials/avatars/avatar-2.jpg';
import Avatar3 from '../assets/images/testimonials/avatars/avatar-3.jpg';
import Avatar4 from '../assets/images/testimonials/avatars/avatar-4.jpg';

export const listTestimonials = [
  {
    id: 1,
    name: 'Pedro',
    profession: 'Empresário',
    description:
      'Muito obrigado, agora meu quarto é mais luxuoso e parece caro',
    userImage: Avatar1,
    productPhoto: Photo1,
    starRating: 4
  },
  {
    id: 2,
    name: 'Maria Júlia',
    profession: 'Modelo',
    description:
      'Obrigada Panto, agora estou com vontade de morar em um apartamento porque as coisas parecem luxuosas.',
    userImage: Avatar2,
    productPhoto: Photo2,
    starRating: 5
  },
  {
    id: 3,
    name: 'Joana',
    profession: 'Arquiteta',
    description: 'Estou encantada... Tudo muito lindo, e acessível. Amei!! 😍',
    userImage: Avatar3,
    productPhoto: Photo3,
    starRating: 5
  },
  {
    id: 3,
    name: 'Ana',
    profession: 'Advogada',
    description:
      'Meu escritório está lindo e luxuoso com Panto!',
    userImage: Avatar4,
    productPhoto: Photo1,
    starRating: 5
  }
];
